
const Reviews = [
    {
        name:"Dr.Abhilah Vijayannair & Family",
        date:"5 Jan 2024 Singapore Cruise ",
        review:"A big thank you to Mr. Gulshan Bhaskar and the Tirun Travel Marketing Limited team for making our New Year cruise from Singapore an unforgettable experience. The seamless organization, breathtaking views, and impeccable service exceeded our expectations. Special appreciation to Mr. Bhaskar for his professionalism and dedication in ensuring every detail was perfect. Looking forward to future collaborations and highly recommending Tirun Travel Marketing Limited!"

    },
    {
        name:"Upayan Dutta",
        date:"22 Dec 2023 Singapore Cruise",
        review:"We celebrated our 10th wedding anniversary with a spectacular cruise on Royal Caribbean's Spectrum of the Seas, thanks to TIRUN's exceptional support. Special thanks to Mr. Rohit Jaiswal for his impeccable service, seamless booking process, and assistance with travel insurance. Our first cruise was hassle-free and unforgettable. Highly recommended- looking forward to our next vacation with TIRUN!"

    },
    {
        name:"Reuben Thomas Lal",
        date:"12 Sep 2022 Singapore Cruise",
        review:"Dear Mahima, I sincerely appreciate your help in planning our wonderful cruise vacation. My family had an amazing time, and it wouldn't have been possible without your expertise and assistance. Your excellent communication and prompt responses made the entire process seamless. Thank you once again for making our cruise an unforgettable experience!"
    }

]


export default Reviews;